import AppBarContainer from 'bento-ordering/base/containers/AppBarContainer';
import LogoFocusedAppBarContainer from 'bento-ordering/base/containers/LogoFocusedAppBarContainer';
import { CURVED, LOGO_FOCUSED, STANDARD } from 'constants/customLayouts';
import DefaultScreenHero from 'bento-ordering/base/components/DefaultScreenHero';
import StandardScreenHero from 'bento-ordering/base/components/StandardScreenHero';
import StandardMenuHeroLocationInformationWithoutImage from 'bento-ordering/menus/components/StandardMenuHeroLocationInformationWithoutImage';
import LogoFocusedScreenHero from 'bento-ordering/base/components/LogoFocusedScreenHero';
import CurvedScreenLogoHero from 'bento-ordering/base/components/CurvedScreenLogoHero';

// TODO: Update this with proper components
const CUSTOM_LAYOUT_NAVBAR = {
  [STANDARD]: AppBarContainer,
  [LOGO_FOCUSED]: LogoFocusedAppBarContainer,
  [CURVED]: AppBarContainer
};

// TODO: Update this with proper components
const CUSTOM_LAYOUT_HERO = {
  [STANDARD]: StandardScreenHero,
  [LOGO_FOCUSED]: LogoFocusedScreenHero,
  [CURVED]: CurvedScreenLogoHero
};

const CUSTOM_LAYOUT_HERO_WITHOUT_IMAGE = {
  [STANDARD]: StandardMenuHeroLocationInformationWithoutImage,
  [LOGO_FOCUSED]: LogoFocusedScreenHero,
  [CURVED]: CurvedScreenLogoHero
};

export function getCustomLayoutNavbar(layout) {
  return CUSTOM_LAYOUT_NAVBAR?.[layout] ?? AppBarContainer;
}

export function getCustomLayoutHero(layout) {
  return CUSTOM_LAYOUT_HERO?.[layout] ?? DefaultScreenHero;
}

export function getCustomLayoutHeroWithoutImage(layout) {
  return CUSTOM_LAYOUT_HERO_WITHOUT_IMAGE?.[layout] ?? null;
}
